// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1m9KH","main-image":"Header_main-image__2eWY9"};